export const DB_CONFIG = {
    apiKey: "AIzaSyAflHnr1WsJEmNAz4mHeJZaXCk85zlXEpY",
    authDomain: "hunted-4c5e0.firebaseapp.com",
    projectId: "hunted-4c5e0",
    storageBucket: "hunted-4c5e0.appspot.com",
    messagingSenderId: "481846073001",
    appId: "1:481846073001:web:6adc193e85b41f4cc87bb8",
    measurementId: "G-HS7SEMVH77"
};
